const headers = {
  contentType: 'Content-Type',
  trackingId: 'X-SYF-Request-TrackingId'
}

export default headers
